module.exports = __webpack_public_path__ + "static/media/steak.bcc019d1.svg";